import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Arrow } from "../../assets/ArrowDown.svg";
import { ReactComponent as ArrowSmall } from "../../assets/dropdownSmall.svg";
import { useAppContext } from "../../AppContext";
import i18n from "../../locales/i18n";
const LanguageDropdown: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const {language,setLanguage}=useAppContext();
    const [isRTL, setIsRTL] = useState<boolean>(i18n.language === 'ar');

    useEffect(() => {
        const handleLanguageChange = () => {
            setIsRTL(i18n.language === 'ar');
        };
        
        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    const handleClickOutside = (event: MouseEvent) => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div className="relative" ref={ref}>
            <button
                className={`md:h-14 h-12 w-auto flex items-center justify-center px-4 rounded-2xl border border-[#D8DADC]`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <p className="semibold-text text-[#424242] text-xs md:text-base">{language}</p>
                <div className={`ml-[10px] ${isRTL ? 'mr-[10px]' : 'ml-[10px]'} hidden md:block`}>
                    <Arrow />
                </div>
           
            </button>
            {isOpen && (
                <div className="absolute top-[105%] right-0 w-full bg-white shadow-md rounded-lg min-w-[110px]">
                    <div className="flex flex-col gap-2 border-b border-[#D8DADC] hover:bg-[rgba(0,0,0,0.05)] rounded-t-lg">
                        <button onClick={()=>{setIsOpen(false);setLanguage('EN')}} className="flex items-center gap-2 text-sm text-gray-700 hover:bg-gray-100 px-4 py-[14px] rounded-md">
                            EN
                        </button>
                    </div>
                    <div className="flex flex-col gap-2 border-b border-[#D8DADC] hover:bg-[rgba(0,0,0,0.05)] ">
                        <button onClick={()=>{setIsOpen(false);setLanguage('FR')}} className="flex items-center gap-2 text-sm text-gray-700 hover:bg-gray-100 px-4 py-[14px] rounded-md">
                            FR
                        </button>
                    </div>
                    <div className="flex flex-col gap-2 hover:bg-[rgba(0,0,0,0.05)] rounded-b-lg">
                        <button onClick={()=>{setIsOpen(false);setLanguage('AR')}} className="flex items-center gap-2 text-sm text-gray-700 hover:bg-gray-100 px-4 py-[14px] rounded-md">
                            AR
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LanguageDropdown;
